<template>
  <div>
    <div
      v-if="err_msg"
      class="msg msg-error"
    >{{err_msg}}
    </div>
    <div
      v-if="msg"
      class="msg msg-success"
    >{{msg}}
    </div>
    <b-form
      @submit="onSubmit"
      v-if="!done"
    >
      <b-form-group
        label="輸入您的電子信箱，系統會寄發重設密碼郵件"
        label-for="email-input"
      >
        <b-form-input
          id="email-input"
          v-model="form.email"
          type="email"
          required
          placeholder="請輸入電子信箱"
        ></b-form-input>
      </b-form-group>
      <b-button
        type="submit"
        class="w-100 d-flex justify-content-center align-items-center"
        variant="orange"
        :disabled="processing"
      >
        <b-spinner
          small
          class="mr-1"
          v-if="processing"
        ></b-spinner>{{processing ? '處理中' : '送出'}}
      </b-button>
    </b-form>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'forget-password',
  props: ['invalid'],
  created () {
    this.initialize()
  },
  data: function () {
    return {
      // parameter
      err_msg: '',
      msg: '',
      done: false,
      processing: false,
      // data
      form: {
        email: ''
      }
    }
  },
  methods: {
    initialize () {
      if (this.invalid) {
        this.err_msg = '您的連結已失效，請重新嘗試'
      }
    },
    sendPasswordReset: _.debounce(function () {
      let _vue = this
      if (!_vue.processing) {
        _vue.processing = true
        _vue.$api(_vue, { method: 'post', url: `/api/Account/Password/Reset/Create?email=${_vue.form.email}` })
          .then(response => {
            _vue.done = true
            _vue.msg = '已寄出電子郵件，請至信箱收信'
            _vue.err_msg = ''
          }, reason => {
            if (reason.response.data.code === 'NotFound') {
              _vue.err_msg = '找不到該用戶'
            }
          }).finally(() => {
            _vue.processing = false
          })
      }
    }, 200),
    onSubmit (evt) {
      evt.preventDefault()
      if (this.form.email) {
        this.sendPasswordReset()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";

.msg {
  padding: 0.5rem 1rem;
  margin-bottom: 0.2rem;
  border-radius: 10px;
  font-size: 0.8rem;
  &-error {
    background-color: $papayum_lignt_orange;
    color: $dark_orange;
  }
  &-success {
    background-color: $green;
    color: $basic-black;
  }
}
form {
  background: $light-gray;
  padding: 1rem;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ForgetPasswordBlock.vue